export default "__VITE_ASSET__BiWZe3Bs__"